module.exports = __webpack_public_path__ + "img/alternativa8.20dddc59.png";